import {
    FETCH_EMP_ALLOCATION_CDLJOBS_REQUEST,
    FETCH_EMP_ALLOCATION_CDLJOBS_SUCCESS,
    FETCH_EMP_ALLOCATION_CDLJOBS_FAILURE,
} from "../constants/EmpAllocationCDLJobsConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const EmpAllocationCDLJobsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EMP_ALLOCATION_CDLJOBS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_EMP_ALLOCATION_CDLJOBS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_EMP_ALLOCATION_CDLJOBS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default EmpAllocationCDLJobsReducer;
